export default __webpack_public_path__ + "static/media/Group 16.4c89e169.svg";